<!-- <p>product-card works!</p> -->
<!-- <app-shared-form #myFormComponent [sections]="mySections"></app-shared-form> -->
<div class="flex items-start space-x-4">
<div class="w-12 h-12 border-2 border-red-500 rounded-full flex items-center justify-center text-red-500">
    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7h4l2 2h10a1 1 0 011 1v7a1 1 0 01-1 1H3V7z" />
    </svg>
</div>
<select>
  <option *ngFor="let prod of productData" [value]="prod.productId">{{prod.label}}</option>
</select>
<h1 class="text-2xl pt-2 pb-2">{{ textData['rackspace_email'] }}</h1>
</div>
<div class="border-gray-300">
        <div class="w-full pb-2 mt-4">
            <span style="float: left;">{{ textData['price'] }}</span>
            <span style="float: right;">{{ textData['quantity'] }}</span>
        </div>
        <hr class="border-t-2 border-gray-300 mb-2 mt-4 w-full">
        <div class="w-full mt-4">
            <span class="text-lg font-medium">${{ productData.apps[0].price }} {{ textData['per_mailbox_per_month'] }}</span>
            <input type="text"
                class="w-16 border border-gray-300 shadow-sm bg-gray-50 float-right text-center"
                 value="1"/>
                 <input type="hidden" name="{{ productData.apps[0].label }}" value="{{ productData.apps[0].productId }}" >
        </div>
        <div class="w-full mt-10 mb-10">
            <p class="text-xs">{{ productData.apps[0].limit }} </p>
            <p class="text-xs mt-6">{{ productData.apps[0].description }} </p>
        </div>
    </div>
    <div>
        <h2 class="mt-2 mb-2 font-bold">{{ textData['signups_addons_options'] }}</h2>
    </div>
    <hr class="border-t-2 border-gray-300 mb-2 mt-4 w-full">
<div *ngFor="let block of features" class="border border-blue-500 rounded-lg p-4 relative bg-white shadow-md w-full mb-4 mx-auto mb-6">
  <!-- ADD-ON Ribbon -->
  <div class="absolute top-10 right-0 bg-red-600 text-white text-xs px-2 py-1 rotate-45 origin-top-right transform translate-x-5 -translate-y-2 shadow-lg">
    ADD-ON
  </div>

  <div class="flex items-start space-x-4">
    <!-- Checkbox -->
    <div class="w-8 flex-none m-1 p-2 justify-center">
    <input type="checkbox" id="{{ block.productId }}" value="{{ block.productId }}" class="mt-2 w-3 h-3 text-blue-600 border-blue-500 focus:ring-blue-500" />
    </div>
    <div class="w-54 flex-none">
    <div class="flex items-start space-x-4">
      <!-- Icon -->
      <div class="w-12 h-12 border-2 border-red-500 rounded-full flex items-center justify-center text-red-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7h4l2 2h10a1 1 0 011 1v7a1 1 0 01-1 1H3V7z" />
        </svg>
      </div>

      <!-- Title & Toggle -->
      <div>
        <h2 class="text-xl font-medium text-gray-600">{{ block.title }}</h2>
        <p class="text-sm text-gray-600">{{ block.description }}</p>
        <button (click)="toggleFeature(block)" class="text-blue-600 text-xs font-medium mt-1 flex items-center space-x-1">
          <span>{{ block.showFeatures ? 'See All Features' : 'See All Features' }}</span>
          <svg class="w-4 h-4 transform transition-transform duration-300"
               [class.rotate-180]="block.showFeatures"
               xmlns="http://www.w3.org/2000/svg"
               fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>
      </div>
    </div>
    </div>
  </div>

  <!-- Toggle List -->
  <div
    class="transition-all duration-300 ease-in-out overflow-hidden"
    [ngClass]="{
      'max-h-0': !block.showFeatures,
      'max-h-[1000px] mt-4': block.showFeatures
    }"
  >
  <hr class="border-t-2 border-blue-300 mb-4 mt-4 w-full">
  <div class="flex">
  <div class="w-8 flex-none">
    </div>
    <div class="w-54 flex-none">
    <ul class="text-sm text-gray-800 list-disc pl-6 space-y-1 ">
      <li *ngFor="let item of block.features" class="text-600">{{ item }}</li>
    </ul>
  </div>
  </div>
  </div>
</div>

